const flashFeatureState = state => state.features.common.flash;

export const allMessages = flashFeatureState;



// WEBPACK FOOTER //
// ./src/store/features/common/flash/selectors.js